import React from "react";

const Footer = (props) => {
  return (
    <footer class="footer-box">
      <div class="container text-center">
        <p class="text-light mb-0">
          © 2021
          <a className="creator-name" href="https://oneeyehealer.github.io">
            OneEyeHealer
          </a>
          All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
